import React, { useEffect, useState } from "react";

import { ButtonSelect } from "../../form-inputs/inputs";
import * as notify from "../../../shared/notify";
import * as logger from "../../../shared/logger";
import eventEmitter from "../../../shared/events";
import { useInput } from "../../../shared/hooks/form-fields";

import { getSenders, requestMeasurements, deleteCubiscanMeasurements } from "../lib/measuring-data";

const stopPolling = (intervalId) => {
    return () => {
        clearInterval(intervalId);
    };
};

const RequestMeasurements = (props) => {
    const selectedSender = useInput("");
    const [pollingError, setPollingError] = useState(false);
    const [senders, setSenders] = useState([]);
    const [isProcessing, setIsProcessing] = useState(false);

    const pollingNote = pollingError ? <div className="poll-error">Unable to Poll Senders!</div> : null;
    let senderInterval = null;

    const handleRequestMeasurements = async () => {
        if (props.upcNotSelected) {
            notify.error("UPC selection is required when adding measurements.");

            return;
        }

        if (isProcessing) {
            return;
        }

        setIsProcessing(true);
        await getMeasurements();
    };

    useEffect(() => {
        if (props.isCompleted) {
            return;
        }

        senderInterval = setInterval(() => {
            getSenders()
                .catch((err) => {
                    setPollingError(true);
                })
                .then((sendersList) => {
                    if (!sendersList) {
                        return;
                    }

                    setSenders(sendersList);
                    setPollingError(false);
                });
        }, 5000);

        window.GS = {
            stopPolling: stopPolling(senderInterval),
        };

        return () => {
            stopPolling(senderInterval)();
            window.GS = {};
        };
    }, [props.isCompleted]);

    const getMeasurements = async () => {
        if (!selectedSender.value) {
            notify.warning("Please select a sender");
            setIsProcessing(false);

            return;
        }

        let measurements;
        try {
            measurements = await requestMeasurements(selectedSender.value);
        } catch (err) {
            logger.error(err.message);
            notify.error("Unable to request measurements");
            setIsProcessing(false);

            return;
        }

        const newMeasurements = measurements.map((m) => {
            return {
                weight: m.weight,
                height: m.height,
                depth: m.depth,
                width: m.width,
                positionValue: props.currentPosition.value,
                type: m.measurementType,
            };
        });

        const savePromises = newMeasurements.map((measurement) => {
            return props.saveMeasurement(props.measurementState, measurement, true);
        });

        await Promise.all(savePromises).then((data) => {});

        if (measurements.length > 0) {
            await deleteCubiscanMeasurements(
                measurements.map((m) => {
                    return m.key;
                })
            );
        }

        eventEmitter.emit("REFRESH_TASK_STATUS");
        setIsProcessing(false);
    };

    return (
        <div>
            {pollingNote}
            <div className="input-group">
                <ButtonSelect
                    label="Sender"
                    name="currentSender"
                    {...selectedSender.bind}
                    options={senders}
                    className="-full"
                    buttonClick={handleRequestMeasurements}
                    buttonText="Request"
                    disabled={isProcessing || props.isCompleted}
                />
            </div>
        </div>
    );
};

export default RequestMeasurements;
